/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Styles from './EmprestimoGarantiaCarroContrato.css';
import EmprestimoGarantiaCarroContratoVantagens from '@/components/organisms/EmprestimoGarantiaCarroContratoVantagens';
import EmprestimoGarantiaCarroContratoPassoaPasso from '@/components/organisms/EmprestimoGarantiaCarroContratoPassoaPasso';
import EmprestimoGarantiaCarroContratoBoletoVenceu from '@/components/organisms/EmprestimoGarantiaCarroContratoBoletoVenceu';
import EmprestimoGarantiaCarroContratoDA from '@/components/organisms/EmprestimoGarantiaCarroContratoDA';
import EmprestimoGarantiaCarroCondicoes from '@/components/organisms/EmprestimoGarantiaCarroCondicoes';
import EmprestimoGarantiaCarroContratoComoFez from '@/components/organisms/EmprestimoGarantiaCarroContratoComoFez';

function EmprestimoGarantiaCarroContrato({ show }) {
  return (
    <>
      <div id="page-emprestimo-garantia-contrato" className={show ? 'show' : ''}>
        <EmprestimoGarantiaCarroContratoComoFez />
        <EmprestimoGarantiaCarroContratoVantagens />
        <EmprestimoGarantiaCarroContratoPassoaPasso />
        <EmprestimoGarantiaCarroContratoBoletoVenceu />
        <EmprestimoGarantiaCarroContratoDA />
        <EmprestimoGarantiaCarroCondicoes />
      </div>
      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroContrato;
